(ns ycweb.app.blitz.packing.packer.itemlist
  (:require
   [inflections.core :as inflections]
   [rum.core :as rum]
   [util.string :as utilstr]
   [ycweb.components.common :as cmn]
   [ycweb.components.flow :as flow]
   [ycweb.components.grid :as grid]
   [ycweb.components.toaster :as toaster]
   [ycweb.components.transitions :as t]
   [ycweb.components.wrapper :as w]
   [ycweb.util.comms :as comms]
   [ycweb.util.core :as u]
   [ycweb.app.blitz.packing.common :as pack-cmn]))


(defn update-items-qtyscanned [item items]
  (->>
    (conj items item)
    (u/collapse :barcode #(update %1 :qtyscanned (fnil + 0 0) (:qtyscanned %2)))))

(defn item-scan [app-atom {:keys [item] :as param}]
  (let [{:keys [items packbox]} (get-in @app-atom [:packing])

        packbox-items
        (->>
          (get items (:id packbox))
          (update-items-qtyscanned item)
          (filter (comp pos? :qtyscanned)))

        scanned-items
        (->>
          (dissoc items nil)
          (mapcat val)
          (filter (comp #{(:barcode item)} :barcode))
          (update-items-qtyscanned item))

        scanned-qty
        (reduce + (map #(min (:qtyscanned %) (:qty %)) scanned-items))

        remaining-items
        (->>
          (get items nil)
          (remove (comp #{(:barcode item)} :barcode))
          (concat [(assoc item :qtyscanned scanned-qty)])
          (remove #(>= (:qtyscanned %) (:qty %)))
          (remove (comp zero? :qty)))]

    (swap! app-atom update :packing

      #(->
         %
         (assoc :uuid (:uuid param))
         (assoc-in [:items nil] remaining-items)
         (assoc-in [:items (:id packbox)] packbox-items)))))

(defmethod comms/receive :packing/multiscan [app-atom {:keys [packbox item scans] :as e}]
  (toaster/close-subtle-progress app-atom)
  (cond
    packbox
    (swap! app-atom update :packing
      (fn [packing]
        (assoc packing
         :uuid (:uuid e)
         :packbox packbox
         :packboxes (vals (u/index-by :id (conj (:packboxes packing) packbox))))))

    item
    (item-scan app-atom e))

  (when scans
    (let [items (u/index-by :barcode (cmn/curact app-atom [:packing :items nil]))]
      (doseq [scan scans]
        (let [item (get items (:barcode scan))]
          (item-scan app-atom
            {:uuid (:uuid e)
             :item (assoc item :qtyscanned (:qty scan))})))))

  (t/transition-next app-atom :packing/item-list))

(defmethod grid/action :packing/multiscan [app-atom {:keys [scan manual-qty]} _]
  (toaster/open-subtle-progress app-atom)
  (let [{:keys [packbox session-id modal-item order] :as packing}
        (cmn/curact app-atom :packing)]
    (println order)
    (comms/send :packing/multiscan
      {:scan (or scan (:barcode modal-item))
       :qty (or manual-qty 1)
       :uuid (:uuid packing)
       :packbox-id (:id packbox)
       :session-id session-id
       :picking-order-uuid (:po-uuid order)})))

(defmethod flow/barcode-dispatch-screen :packing/item-list [_ app-atom scan]
  (grid/dispatch-action app-atom :packing/multiscan {:scan scan}))

(defmethod grid/action :packing/item-unscan [app-atom {:keys [scan]} _]
  (toaster/open-subtle-progress app-atom)
  (let [{:keys [packbox session-id order] :as packing}
        (cmn/curact app-atom :packing)]
    (comms/send :packing/multiscan
      {:scan scan
       :uuid (:uuid packing)
       :qty -1
       :packbox-id (:id packbox)
       :session-id session-id
       :picking-order-uuid (:po-uuid order)})))

(defmethod flow/barcode-dispatch-modal :packing/modal-item-unscan [_ app-atom scan]
  (grid/dispatch-modal-action app-atom :packing/item-unscan {:scan scan}))

(defmethod grid/modal-config :packing/modal-item-unscan [_ _ _]
  {:body grid/single-input-modal-body
   :footer grid/single-input-modal-footer
   :modal-type :alert})

(defmethod grid/action :packing/menu-unscan [app-atom _ _]
  (grid/open-modal app-atom :packing/modal-item-unscan
    {:config
     {:title "Unscan Product"
      :field-text "Barcode"
      :initial-value ""
      :save-text "Capture"
      :save-key :packing/item-unscan
      :input-key :scan
      :input-type :barcode}}))

(defmethod comms/receive :packing/packing-abandon [app-atom {:keys [status] :as e}]
  (toaster/close-subtle-progress app-atom)
  (let [{:keys [quickship?]} (cmn/curact app-atom :packing)]
    (swap! app-atom update :packing dissoc :order)
    (cond
      quickship?
      (grid/dispatch-action app-atom :packing/quickship {})

      :else
      (grid/dispatch-action app-atom :packing/next-queued-order {}))))

(defmethod grid/action :packing/abandon-reason [app-atom {:keys [location-barcode] :as e} _]
  (toaster/open-subtle-progress app-atom)
  (let [process-atom (cmn/process-cursor app-atom)
        {:keys [packbox session-id order] :as packing} (cmn/curact app-atom :packing)
        abandon-atom (rum/cursor process-atom :abandon-packing)
        reason (cmn/curact abandon-atom :reason)
        missing-items (cmn/curact abandon-atom :items)
        warehouse-id (cmn/curact process-atom [:location :warehouse_id])
        {:packing-desk/keys [location]} (:packdesk packing)
        [_ loc-id] (:externalid/ihdb location)]
    (comms/send :packing/packing-abandon
      (u/maybe assoc
        {:to-location location-barcode
         :packbox packbox
         :session-id session-id
         :warehouse-id warehouse-id
         :reason reason
         :packdesk-location-id loc-id
         :picking-order-uuid (:po-uuid order)}
        :items (when (= reason "Item Missing") (vals missing-items))))))

(defmethod flow/barcode-dispatch-modal :packing/abandon-picking-reason-scan [_ app-atom scan]
  (grid/dispatch-modal-action app-atom :packing/abandon-reason {:location-barcode scan}))

(defmethod grid/modal-config :packing/abandon-picking-reason-scan [_ _ _]
  {:body grid/single-input-modal-body
   :footer grid/single-input-modal-footer
   :modal-type :alert})

(defmethod grid/action :packing/abandon-packing-to-location [app-atom config a]
  (grid/open-modal app-atom :packing/abandon-picking-reason-scan
    {:config
     {:title "Scan to location"
      :initial-value ""
      :save-text "Capture"
      :save-key :packing/abandon-reason
      :input-key :location-barcode
      :input-type :barcode}}))

(defmethod grid/action :packing/cs-agent-not-available [app-atom config action-key]
  (let [process-atom (cmn/process-cursor app-atom)
        reason-config (u/index-by :action (:items config))
        reason (get reason-config action-key)
        reason-label (:label reason)]
    (swap! process-atom assoc-in [:abandon-packing :reason] reason-label)
    (grid/dispatch-action app-atom :packing/abandon-packing-to-location
      {:label reason-label})))

(defmethod grid/action :packing/card-incorrect [app-atom config action-key]
  (let [process-atom (cmn/process-cursor app-atom)
        reason-config (u/index-by :action (:items config))
        reason (get reason-config action-key)
        reason-label (:label reason)]
    (swap! process-atom assoc-in [:abandon-packing :reason] reason-label)
    (grid/dispatch-action app-atom :packing/abandon-packing-to-location
      {:label reason-label})))

(defmethod grid/action :packing/card-missing [app-atom config action-key]
  (let [process-atom (cmn/process-cursor app-atom)
        reason-config (u/index-by :action (:items config))
        reason (get reason-config action-key)
        reason-label (:label reason)]
    (swap! process-atom assoc-in [:abandon-packing :reason] reason-label)
    (grid/dispatch-action app-atom :packing/abandon-packing-to-location
      {:label reason-label})))

(defmethod grid/action :packing/other-abandon-reason [app-atom config action-key]
  (let [process-atom (cmn/process-cursor app-atom)
        reason-config (u/index-by :action (:items config))
        reason (get reason-config action-key)
        reason-label (:label reason)]
    (swap! process-atom assoc-in [:abandon-packing :reason] reason-label)
    (grid/dispatch-action app-atom :packing/abandon-packing-to-location
      {:label reason-label})))

(defmethod grid/action :packing/item-missing [app-atom {:keys [config]} action-key]
  (let [process-atom (cmn/process-cursor app-atom)
        reason-label (:label config)
        missing-items (or (:list config) [])]
    (cond
      (empty? missing-items)
      (toaster/open-toast app-atom :error "No items have been set to shrink" {})

      :else
      (do
        (swap! process-atom assoc-in [:abandon-packing :reason] reason-label)
        (grid/dispatch-action app-atom :packing/abandon-packing-to-location
          {:label reason-label})))))

(rum/defc missing-item < rum/reactive [{:keys [product qty barcode shrink-qty]}]
  [:article.product-slat.packing-product-slat
   {:class (u/bem :slat nil)}
   [:div.product-slat__qty.packing-product-slat__qty
    [:div.packing-product-slat__count
     [:div
      [:b (str "Shrink item" (when (> shrink-qty 1) "s"))]]
     [:span shrink-qty " of " qty]]]
   [:div.product-slat__info
    [:header.product-slat__header
     [:div.product-slat__title-wrapper
      [:h2.product-slat__title product]]]
    [:ul.product-slat__details
     [:li.product-slat__barcode
      [:b.u-text-spaced-1 barcode]]]]])

(rum/defc missing-item-list-body < rum/reactive [app-atom]
  (let [{:keys [title heading] :as missing-config}
        (:config (cmn/curact (grid/modal-cursor app-atom) :config))]
    [[:div.section
      [:div.u-margin-top-24
       [:h2.u-text-center
        {:class (u/bem :heading [:standard])}
        title
        [:span.heading__subtext
         heading]]]]
     [[:div.slats
       (map
         (fn [i]
           (rum/with-key
             (missing-item i)
             (:id i)))
         (:list missing-config))]]]))

(defmethod grid/modal-config :packing/list-missing-items [_ _ _]
  {:body missing-item-list-body
   :footer grid/single-input-modal-footer
   :modal-type :alert})

(defmethod grid/action :packing/list-missing-items [app-atom config _]
  (let [process-atom (cmn/process-cursor app-atom)
        missing-items (cmn/curact process-atom [:abandon-packing :items])]
    (grid/open-modal app-atom :packing/list-missing-items
      {:config
       {:title "Items to shrink"
        :initial-value 0
        :save-text "Submit"
        :save-key :packing/item-missing
        :label (:label config)
        :list (vals missing-items)}})))

(defmethod grid/action :packing/item-qty-abandon [app-atom {:keys [item shrink-qty] :as cfg} _]
  (let [process-atom (cmn/process-cursor app-atom)]
    (cond
      (> shrink-qty (:qty item))
      (toaster/open-toast app-atom :error "The shrink quantity cannot be greater than the item's quantity" {})

      :else
      (swap! process-atom update-in [:abandon-packing :items]
        (fn [items]
          (let [new-item (assoc item :shrink-qty shrink-qty)
                existing-item (get items (:id item))]
            (cond
              (and existing-item (zero? shrink-qty))
              (dissoc items (:id item))

              :else
              (assoc items (:id item) new-item))))))))

(defmethod grid/modal-config :packing/abandon-picking-qty-scan [_ _ _]
  {:body grid/single-input-modal-body
   :footer grid/single-input-modal-footer
   :modal-type :alert})

(defmethod grid/action :packing/abandon-shrink-qty [app-atom config _]
  (grid/open-modal app-atom :packing/abandon-picking-qty-scan
    {:config
     {:title "Missing Quantity"
      :initial-value 0
      :save-text "Capture"
      :save-key :packing/item-qty-abandon
      :input-key :shrink-qty
      :input-type :number}
     :item (:item config)}))

(defmethod grid/action :packing/item-abort-modal [app-atom item _]
  (grid/menu-modal app-atom
    {:items
     [{:label "Missing Item Quantity"
       :action :packing/abandon-shrink-qty
       :config {:item item}}

      {:label "Cancel"
       :action :packing/menu-cancel
       :style
       {:full true :large true :text-link true :on-dark true}}]}))

(defmethod grid/action :packing/abandon-packing-reasons [app-atom _ _]
  (let [process-atom (cmn/process-cursor app-atom)
        missing-items (cmn/curact process-atom [:abandon-packing :items])
        missing-count (count missing-items)]
    (grid/menu-modal app-atom
      {:items
       [{:label "CS Agent Not Available"
         :action :packing/cs-agent-not-available}

        {:label "Card Incorrect"
         :action :packing/card-incorrect}

        {:label "Card Missing"
         :action :packing/card-missing}

        {:label (str missing-count " Item" (when (> missing-count 1) "s") " Missing")
         :action :packing/list-missing-items
         :config {:label "Item Missing"}}

        {:label "Other"
         :action :packing/other-abandon-reason}

        {:label "Cancel"
         :action :packing/menu-cancel}]})))

(defn item-list-modal [app-atom]
  (grid/menu-modal app-atom
    {:items
     [{:label "Abandon Packing"
       :action :packing/abandon-packing-reasons
       :style
       {:full true :large true :negative true
        :icon-left :delete :text-default true :icon-class :3-2}}

      {:label "Unscan Product"
       :action :packing/menu-unscan
       :style
       {:full true :large true :negative true
        :icon-left :delete :text-default true :icon-class :3-2}}

      {:label "Cancel"
       :action :packing/menu-cancel
       :style
       {:full true :large true :text-link true :on-dark true}}]}))

(rum/defc item-slat < rum/reactive
  [overscans-idx remaining-items-idx
   {:keys [qtyscanned product qty barcode ownbox]} & [{:keys [on-click]}]]
  (let [overscan-item (get overscans-idx barcode)
        remaining-item (get remaining-items-idx barcode)
        [slat-color slat-bg-color]
        (cond
          overscan-item
          [:error :error-bg]

          (> qtyscanned qty)
          [:error :error-bg]

          (or (and remaining-items-idx (nil? remaining-item)) (= qtyscanned qty))
          [:success :success-bg]

          (pos? qtyscanned)
          [:warning :warning-bg])]

    [:article.product-slat.packing-product-slat
     {:class (u/bem :slat [slat-color slat-bg-color]) :on-click on-click}
     [:div.product-slat__qty.packing-product-slat__qty
      [:div.packing-product-slat__count
       [(if (zero? qtyscanned) :b.u-text-status-negative :b) qtyscanned]
       [:span.u-pipe "of"]
       [:span qty]]]
     [:div.product-slat__info
      [:header.product-slat__header
       [:div.product-slat__title-wrapper
        [:h2.product-slat__title product]]]
      [:ul.product-slat__details
       [:li.product-slat__barcode
        [:b.u-text-spaced-1 barcode]]]]
     (when ownbox
       [:ul.product-slat__details
        [:li.product-slat__barcode
         [:b "Ownbox"]]])
     [:div
      [:i {:class (u/bem :icon [:block :dots-menu])}]]]))

(defn packbox-colour [overscans-idx items default]
  (cond
    (->>
      items
      (filter
        (comp (set (keys overscans-idx)) :barcode))
      empty?
      not)
    :error

    :else
    default))

(defn packox-full-percentage [packbox items]
  (cond
    (empty? items)
    "0.00"

    :else
    (utilstr/format "%.2f"
      (* 100
        (/
          (reduce +
            (map
              #(*
                 (:qtyscanned %)
                 (*
                   (:lengthmm %)
                   (:widthmm %)
                   (:heightmm %)))
              items))
          (*
            (:lengthmm packbox)
            (:widthmm packbox)
            (:heightmm packbox)))))))

(defmethod comms/receive :packing/box-scan [app-atom {:keys [packbox] :as resp}]
  (toaster/close-subtle-progress app-atom)
  (swap! app-atom update :packing
    (fn [packing]
      (assoc packing
        :uuid (:uuid resp)
        :packboxes (vals (u/index-by :id (conj (:packboxes packing) packbox))))))
  (t/transition-next app-atom :packing/item-list))

(defmethod grid/action :packing/box-scan [app-atom {:keys [scan]} _]
  (toaster/open-subtle-progress app-atom)
  (let [{:keys [printer-barcode session-id] :as packing}
        (cmn/curact app-atom :packing)]
    (grid/close-modal app-atom)
    (comms/send :packing/box-scan
      {:scan scan
       :uuid (:uuid packing)
       :printer-barcode printer-barcode
       :session-id session-id})))

(rum/defc box-slat < rum/reactive [box {:keys [on-click]}]
  [:article.slat-wrapper
   [:div.slat.packing-box-list-slat
    {:on-click on-click}
    [:h3.packing-box-list-title
     (:name box)]]])

(rum/defc box-list-body < rum/reactive [app-atom]
  (let [{:keys [title heading] :as box-config} (cmn/curact (grid/modal-cursor app-atom) :config)]
    [[:div.section
      [:div.u-margin-top-24
       [:h2.u-text-center
        {:class (u/bem :heading [:standard])}
        title
        [:span.heading__subtext
         heading]]]]
     [[:div.slats
       (map
         (fn [i]
           (rum/with-key
             (box-slat i
               {:on-click #(grid/dispatch-action app-atom :packing/box-scan {:scan (:barcode i)})})
             (:id i)))
         (:list box-config))]]]))

(defmethod flow/barcode-dispatch-modal :packing/modal-box-list [_ app-atom scan]
  (grid/dispatch-action app-atom :packing/box-scan {:scan scan}))

(defmethod grid/modal-config :packing/modal-box-list [_ _ _]
  {:body box-list-body
   :footer grid/list-modal-footer
   :modal-type :details
   :content-type :fill})

(defmethod grid/action :packing/item-menu-qty [app-atom _ _]
  (grid/single-input-modal app-atom
    {:title "Capture manual qty"
     :field-text "Qty"
     :initial-value ""
     :save-text "Capture"
     :save-key :packing/multiscan
     :input-key :manual-qty
     :input-type :number}))

;;Override item quantity (speeds up scanning process)
(defmethod grid/action :packing/item-modal [app-atom item _]
  (swap! app-atom assoc-in [:packing :modal-item] item)
  (grid/menu-modal app-atom
    {:items
     [{:label "Manual Qty"
       :action :packing/item-menu-qty}

      {:label "Cancel"
       :action :packing/menu-cancel
       :style
       {:full true :large true :text-link true :on-dark true}}]}))

(rum/defc landing-screen < rum/reactive [app-atom steps]
  (let [packing-atom (rum/cursor app-atom :packing)
        {:keys [refid receivername size packlane site
                to-packinghint packinghint]}
        (cmn/curact packing-atom :order)
        [colour colour-bg] (pack-cmn/order-size-colour (:name size) nil)
        box (first (cmn/curact packing-atom :boxes))
        items (cmn/curact packing-atom :items)
        boxes (cmn/curact packing-atom :boxes)
        packbox (cmn/curact packing-atom :packbox)
        remaining-packboxes (remove (comp #{(:id packbox)} :id) (cmn/curact packing-atom :packboxes))
        remaining-items (get items nil)
        remaining-items-idx (u/index-by :barcode remaining-items)

        scanned-items
        (->>
          (dissoc items nil)
          (mapcat val)
          (u/collapse :barcode #(update %1 :qtyscanned (fnil + 0 0) (:qtyscanned %2))))

        qty
        (->>
          (mapcat val items)
          (group-by :barcode)
          vals
          (map first)
          (map :qty)
          (reduce +))

        scanned-qty
        (reduce + (map #(min (:qtyscanned %) (:qty %)) scanned-items))

        overscans-idx
        (->>
          scanned-items
          (filter #(> (:qtyscanned %) (:qty %)))
          (u/index-by :barcode))

        allow-next?
        (and (empty? overscans-idx) (= scanned-qty qty))]
    (w/wrapper app-atom "Packing" {:modal-fn item-list-modal :steps steps :step :item-list}
      [[:div.section
        [:h2.u-text-center
         {:class (u/bem :heading [:standard :flush])}
         receivername]
        [:h2.u-text-center
         {:class (u/bem :heading [:standard :flush])}
         (str "Pack Order: " site refid)
         [:span.heading__subtext
          [:span {:class (u/bem :pill [:medium colour])} (:name size)]]]
        [:h2.u-text-center
         {:class (u/bem :heading [:medium-large])}
         [:b.u-barcode packlane]
         [:span.heading__subtext (str (str scanned-qty " of " qty " items packed"))]
         [:span.heading__subtext (str "From Location : " packinghint)]
         [:span.heading__subtext (str "To Location : " to-packinghint)]]]
       (when packbox
         (let [items (get items (:id packbox))
               item-count (reduce + (map :qtyscanned items))
               full-percentage (packox-full-percentage packbox items)]
           [[:div.slats
             [:a.action-button-slat.packing-box-slat
              {:class (u/bem :slat [(packbox-colour overscans-idx items :success)])
               :on-click nil}
              [:div.action-button-slat__icon-wrapper
               [:i {:class (u/bem :icon [:block :package])}]]
              [:div.action-button-slat__title
               [:b (str "Packbox " (:barcode packbox) " - " (:vname packbox))]
               [:span.action-button-slat__subtext (str (inflections/pluralize (or item-count 0) "Item") " Packed | " full-percentage "% full")]]
              [:div.action-button-slat__icon-wrapper
               [:i {:class (u/bem :icon [:block :dots-menu])}]]]
             (map
               (fn [i]
                 (rum/with-key
                   (item-slat
                     overscans-idx
                     remaining-items-idx
                     i
                     {:on-click #(grid/dispatch-action app-atom :packing/item-modal i)})
                   (:id i)))
               items)]]))

       (when-not (empty? remaining-items)
         [[:div.slats
           [:a.action-button-slat
            {:class (u/bem :slat nil)
             :on-click
             (fn []
               (grid/open-modal app-atom :packing/modal-box-list
                 {:title "Choose a box type"
                  :heading "to print a PB label"
                  :list boxes}))}
            [:div.action-button-slat__icon-wrapper
             [:i {:class (u/bem :icon [:block :package])}]]
            [:div.action-button-slat__title.u-text-underline
             (if packbox
               [:b "Add another box"]
               [:b (str "Select or Scan Box (recommended " (:name box) ")")])]
            [:div.action-button-slat__icon-wrapper
             [:i {:class (u/bem :icon [:block :plus])}]]]]
          [(map
             (fn [i]
               (rum/with-key
                 (item-slat
                   overscans-idx
                   false
                   i
                   {:on-click #(grid/dispatch-action app-atom :packing/item-abort-modal i)})
                 (:id i)))
             remaining-items)]])

       (when-not (empty? remaining-packboxes)
         [:div.slats
          [:a.action-button-slat
           {:class (u/bem :slat nil)
            :on-click nil}
           [:div.action-button-slat__icon-wrapper
            [:i {:class (u/bem :icon [:block :package])}]]
           [:div
            [:div.action-button-slat__title
             [:b "Other Packboxes"]]]]])

       (map
         (fn [i]
           (let [items (get items (:id i))
                 item-count (reduce + (map :qtyscanned items))
                 full-percentage (packox-full-percentage packbox items)]
             [[:a.action-button-slat.packing-box-slat
               {:class (u/bem :slat [(packbox-colour overscans-idx items nil)])
                :on-click nil}
               [:div.action-button-slat__icon-wrapper
                [:i {:class (u/bem :icon [:block :package])}]]
               [:div.action-button-slat__title
                [:b (str "Packbox " (:barcode i) " - " (:vname i))]
                [:span.action-button-slat__subtext (str (inflections/pluralize (or item-count 0) "Item") " Packed | " full-percentage "% full")]]
               [:div.action-button-slat__icon-wrapper
                [:i {:class (u/bem :icon [:block :dots-menu])}]]]
              (map
                (fn [i]
                  (rum/with-key
                    (item-slat
                      overscans-idx
                      remaining-items-idx
                      i)
                    (:id i)))
                items)]))
         remaining-packboxes)]

      []
      (grid/pos-call-to-action
        {:left-fn #(grid/dispatch-action app-atom :packing/abandon-packing-reasons {})
         :right-text (if allow-next? "PACKED" "SCAN ITEMS")
         :right-fn (when allow-next? #(grid/dispatch-action app-atom :packing/pack {}))
         :right-plain true}))))

(defmethod comms/receive :packing/pack [app-atom _]
  (toaster/close-subtle-progress app-atom)
  (let [packing-atom (rum/cursor app-atom :packing)
        {:keys [quickship?]} (cmn/curact app-atom :packing)]
    (swap! packing-atom dissoc :order)
    (cond
      quickship?
      (grid/dispatch-action app-atom :packing/quickship {})

      :else
      (grid/dispatch-action app-atom :packing/next-queued-order {}))))

(defmethod grid/action :packing/pack [app-atom _ _]
  (toaster/open-subtle-progress app-atom)
  (let [{:keys [items session-id order] :as packing}
        (cmn/curact app-atom :packing)
        {:packing-desk/keys [location]} (:packdesk packing)
        [_ loc-id] (:externalid/ihdb location)]
    (comms/send :packing/pack
      {:session-id session-id
       :items
       (->>
         (mapcat val items)
         (group-by :barcode)
         vals
         (map first))
       :uuid (:uuid packing)
       :packdesk-location-id loc-id
       :picking-order-uuid (:po-uuid order)})))